import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row } from 'react-bootstrap';
import { Nav, NavItem, Navbar, NavDropdown, MenuItem } from 'react-bootstrap';
import './TopLevelNavBar.scss';

class TopLevelNavBar extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="TopLevelNavContainer">
        <Grid>
          <Row>
            <Navbar collapseOnSelect>
              <Navbar.Header>
                <Navbar.Toggle />
              </Navbar.Header>
              <Navbar.Collapse>
                <Nav>
                  <NavItem className="navitemSeleted" href="./index.html">
                    EXPERIENCES
                  </NavItem>
                  <NavItem
                    className="navitemUnselected"
                    href="https://protection.asurion.com/smarthomesupport/en-us/authenticate?cid=in-rtm:shs"
                  >
                    FILE A CLAIM
                  </NavItem>
                  <NavItem
                    className="navitemUnselected"
                    href="https://www.smarthomesupport.com/frequently-asked-questions/"
                  >
                    FAQ
                  </NavItem>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (/*state, ownProps*/) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopLevelNavBar);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/TopLevelNavBar/TopLevelNavBar.js